
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import Button from '@mui/material/Button';
import { getAccessToken } from 'utils/accessTokenStore';

export default function DebugPage() {
  const token = getAccessToken() || '';
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    if (!token) {
      return;
    }

    try {
      await navigator.clipboard.writeText(token);
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch (error) {
      console.error('Could not copy token', error);
    }
  };

  return (
    <div className="content-surface">
      <p style={{ margin: 0, fontWeight: 600 }}>Token:</p>
      <div style={{ marginTop: '12px', display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
        <code style={{ wordBreak: 'break-all', whiteSpace: 'pre-wrap', display: 'inline-block', flex: 1 }}>{token || 'No token available'}</code>
        <Button
          variant={copied ? 'contained' : 'outlined'}
          color={copied ? 'success' : 'primary'}
          size="small"
          onClick={handleCopy}
          disabled={!token}
          startIcon={copied ? <CheckIcon /> : <ContentCopyOutlinedIcon />}
        >
          {copied ? 'Copied' : 'Copy token'}
        </Button>
      </div>
    </div>
  );
}
